<template>
    <app-transition>
        <Dialog
            class="SubscriptionPrice"
            :only-text="true"
            :closeable="true"
            @close="$emit('close');"
        >
            <v-row text-center="">
                <v-col>
                    <div class="SubscriptionPrice-title">
                    {{ $t('dialogs.received_box_prize_confirmation') }}
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn outlined block class="text-capitalize" @click="confirmPriceGiven">
                        {{ $t('dialogs.yes') }}
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn outlined block class="text-capitalize" @click="handleClose">
                        {{ $t('dialogs.no') }}
                    </v-btn>
                </v-col>
            </v-row>
        </Dialog>
    </app-transition>
</template>


<script>
import Dialog from "@/components/app/form/Dialog";
import { CURRENCY_SYMBOL } from "@/configs/constants";
export default {
    name: "ReceivedBoxPrizeDialog",
    data: () => ({
        currency: CURRENCY_SYMBOL,
    }),
    methods: {
        handleClose() {
            this.$emit('priceNotGiven');
        },
        confirmPriceGiven() {
            this.$emit('confirmPriceGiven');
        }
    },
    computed: {
    },
    props: {        
    },
    components: {
        Dialog,
    }
}
</script>

<style scoped lang="scss">

</style>
